import Vue from 'vue'
import Vuex from 'vuex'
import {ByjoveStoreConfig} from 'byjove'

Vue.use(Vuex)

let VerandaStoreConfig = ByjoveStoreConfig

VerandaStoreConfig.state.expose_home = false
VerandaStoreConfig.state.expose_payments = false
VerandaStoreConfig.state.settings_established = false

VerandaStoreConfig.mutations.SET_EXPOSE_HOME = function(state, expose_home) {
    state.expose_home = expose_home
}

VerandaStoreConfig.mutations.SET_EXPOSE_PAYMENTS = function(state, expose_payments) {
    state.expose_payments = expose_payments
}

VerandaStoreConfig.mutations.SET_SETTINGS_ESTABLISHED = function(state, established) {
    state.settings_established = established
}

export default new Vuex.Store(VerandaStoreConfig)
